import { render } from "./theme4.vue?vue&type=template&id=6bcd6e46&scoped=true"
import script from "./theme4.vue?vue&type=script&lang=js"
export * from "./theme4.vue?vue&type=script&lang=js"

import "./theme4.vue?vue&type=style&index=0&id=6bcd6e46&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6bcd6e46"

export default script